var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-online-view"},[_c('vs-chip',[_c('vs-icon',{attrs:{"icon":"online_prediction"}}),_c('span',[_vm._v("Online")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }